import getDictViewCnt from '../api/dictionary/getDictViewCnt'
import { dictArr } from './dictArr'

const objDictViewCnt: any = {}

// 검색어와 일치하는지 여부 판단
export const getSearchWord = (dictResult: any) => {
  let rtnValue = ''
  const dictIdx = dictResult.dictIdx

  if (dictArr[dictIdx].viewDictNm === 'eng' && dictResult.hasOwnProperty('WORD')) {
    rtnValue = dictResult.WORD
  } else if (
    (dictArr[dictIdx].viewDictNm === 'word' ||
      dictArr[dictIdx].viewDictNm === 'elem' ||
      dictArr[dictIdx].viewDictNm === 'wj' ||
      dictArr[dictIdx].viewDictNm === 'iss' ||
      dictArr[dictIdx].viewDictNm === 'kor') &&
    dictResult.hasOwnProperty('HEADWD')
  ) {
    rtnValue = dictResult.HEADWD
  } else if (
    (dictArr[dictIdx].viewDictNm === 'relic' ||
      dictArr[dictIdx].viewDictNm === 'natural' ||
      dictArr[dictIdx].viewDictNm === 'cultural' ||
      dictArr[dictIdx].viewDictNm === 'sight' ||
      dictArr[dictIdx].viewDictNm === 'woorimal') &&
    dictResult.hasOwnProperty('HEADWD_NAME')
  ) {
    rtnValue = dictResult.HEADWD_NAME
  } else if (dictResult.hasOwnProperty('HEADWD')) {
    rtnValue = dictResult.HEADWD
  } else if (dictResult.hasOwnProperty('HEADWD_NAME')) {
    rtnValue = dictResult.HEADWD_NAME
  }

  return rtnValue
}

// 동음이의어가 2개 이상일 경우 순서 재 설정해주는 함수
async function getArrDictViewCntSort(arrObj: any[]) {
  var rtnObj = arrObj
  var objIds: any = {}
  var ids = ''

  // 파라미터가 너무 길어 100개씩 잘라서 호출
  var idsNumber = -1
  var idsSize = 100

  for (var iCnt = 0; iCnt < arrObj.length; iCnt++) {
    if (iCnt % idsSize === 0) {
      idsNumber++
      ids = ''
    }

    var tmpObj = arrObj[iCnt]
    var tmpDictCd = dictArr[tmpObj.dictIdx].dictCd
    var tmpUniqId = tmpObj[dictArr[tmpObj.dictIdx].apiDictSeqNm]

    if (tmpDictCd != null && tmpDictCd !== undefined && tmpUniqId != null && tmpUniqId !== undefined) {
      if (objDictViewCnt.hasOwnProperty(tmpDictCd + '_' + tmpUniqId)) {
        // 한번 조회한 상태이면 조회하지 않음
      } else {
        if ('' !== ids) {
          ids += ','
        }
        ids += tmpDictCd + '_' + tmpUniqId

        objDictViewCnt[tmpDictCd + '_' + tmpUniqId] = 0
      }
    }

    objIds[idsNumber] = ids // 예시) "ids":"ECCPD_33088,ECCPD_417" (사전아이디_단어번호?)
  }

  if ('' != ids || idsNumber > 0) {
    for (iCnt = 0; iCnt <= idsNumber; iCnt++) {
      if (objIds[iCnt] != '') {
        // 이런식으로 요청을 보내면 각 ids에 대해 콤마(,)로 구분해서 결과가 넘어오게됨
        await getDictViewCnt(objIds[iCnt], objDictViewCnt)
      }
    }

    rtnObj = rtnObj.map(function (o, i) {
      o.idxx = i
      return o
    })

    rtnObj.sort(function (a, b) {
      var aVal = 0
      var bVal = 0

      var aDictCd = dictArr[a.dictIdx].dictCd
      var aDictUniqId = a[dictArr[a.dictIdx].apiDictSeqNm]

      var bDictCd = dictArr[b.dictIdx].dictCd
      var bDictUniqId = b[dictArr[b.dictIdx].apiDictSeqNm]

      if (objDictViewCnt.hasOwnProperty(aDictCd + '_' + aDictUniqId)) {
        aVal = objDictViewCnt[aDictCd + '_' + aDictUniqId]
      } else {
        aVal = 0
      }

      if (objDictViewCnt.hasOwnProperty(bDictCd + '_' + bDictUniqId)) {
        bVal = objDictViewCnt[bDictCd + '_' + bDictUniqId]
      } else {
        bVal = 0
      }

      if (aVal > bVal) {
        return -1
      }
      if (aVal < bVal) {
        return 1
      }

      if (aVal == bVal) {
        if (a.idxx < b.idxx) {
          return -1
        } else {
          return 1
        }
      }

      // a must be equal to b
      return 0
    })
  }

  return rtnObj
}

// 사전종류가 동일하고 동음이의어가 2개 이상인 경우를 찾아서 정렬
export async function dictViewCntSort(arrDictFirstContMap: any[], arrDictContMap: any[]) {
  const newArr = arrDictFirstContMap.concat(arrDictContMap) // 일단 합침

  let sortArr: any[] = []
  let tmpArr: any[] = []

  let preSearchWord = ''
  let preIdx = ''
  let preActive = false
  let preIsFirst = false

  let length = newArr.length

  for (var iCnt = 0; iCnt < length; iCnt++) {
    const tmpObj = newArr[iCnt].map
    const curSearchWord = getSearchWord(tmpObj)
    const curIsFirst = tmpObj.isFirst
    const curIdx = tmpObj.dictIdx

    // isFirst가 true인건 false와는 변경되지 않도록 함(우선순위는 변동X)
    if (preIsFirst !== curIsFirst) {
      preActive = false
    }
    // 동음이의어이면서 사전 종류가 같은 경우 순서 정렬
    else if (preSearchWord === curSearchWord && preIdx === curIdx) {
      preActive = true
    }
    // 음...?
    else {
      preActive = false
    }

    // 동음이의어를 찾다가 더이상 나오지 않은경우를 판단하기 위해
    if (!preActive && iCnt > 0) {
      if (tmpArr.length > 1) {
        // 동음이의어가 2개 이상일 경우 순서 재 설정
        tmpArr = await getArrDictViewCntSort(tmpArr)
      }

      // tmpArr 기준으로 뷰카운트를 조회하여 순서 변경
      sortArr = sortArr.concat(tmpArr)
      tmpArr = []
    }

    tmpArr.push(tmpObj)

    if (iCnt === newArr.length - 1) {
      if (tmpArr.length > 1) {
        tmpArr = await getArrDictViewCntSort(tmpArr)
      }
      sortArr = sortArr.concat(tmpArr)
    }

    preSearchWord = curSearchWord
    preIsFirst = curIsFirst
    preIdx = curIdx
  }

  return sortArr
}
